import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "email-confirm",
  class: "flex flex-column text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5" }, "Confirm your email", -1)
const _hoisted_3 = { class: "mx-auto" }

import UserEmailConfirm from '@/components/UserEmailConfirm.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(UserEmailConfirm)
    ])
  ]))
}
}

})